import { UPDATE_STORE_EMPLOYEE } from "../constants/endpoints";
import axiosClient from "./axios";

interface UpdateStoreEmployeeData {
  userId: number;
  shopId: string;
  name: string;
  email?: string;
  phoneNumber?: string;
  role?: string;
  config?: { allowedCategories?: string[] };
}

class updateStoreEmployee {
  static async updateStoreEmployee(data: UpdateStoreEmployeeData) {
    const response = await axiosClient.put(UPDATE_STORE_EMPLOYEE, data);
    return response;
  }
}

export default updateStoreEmployee;
